import styles from "./styles.module.scss";
import Images from "../../../../../assets/images";
import {
  ChowdeckConnectIcon,
  ConnectStoreIcon,
  LumiIcon,
} from "../../../../../assets/svgIcons";
import Icon from "../../../../../assets/icons";
import primaryComponents from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import {
  useGetMarketPlaceConnections,
  useGetStoresMappingList,
} from "../../../../../hooks/api/queries/useMarketPlace";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import {
  createConnection,
  updateConnection,
} from "../../../../../services/marketplace";
import { ToastContext } from "../../../../../hooks/context";
import CopyToClipboard from "react-copy-to-clipboard";

const ApiManagement = ({
  chowdeckSecretKey,
  setChowdeckSecretKey,
  successModal,
  setSuccessModal,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const triggerToast = useContext(ToastContext);
  const [search, setSearch] = useSearchParams();

  const connection_id = search.get("id");
  const queryText = search.get("query");

  const [secretKey, setSecretKey] = useState("");
  const [showYouTubeModal, setShowYouTubeModal] = useState(false);

  const { data: marketPlaceConnections } = useGetMarketPlaceConnections({
    isEnabled: connection_id ? true : false,
  });
  const { data: storesMappingList } = useGetStoresMappingList({
    queries:
      queryText && queryText.length > 0
        ? `?marketplace_type=CHOWDECK&query=${queryText}`
        : "?marketplace_type=CHOWDECK",
  });

  const { isLoading, mutate } = useMutation({
    mutationFn: (data) => createConnection(data),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      search.set("id", data?.data?.data?.id);
      setSearch(search, { replace: true });
      navigate(
        `${pathConstants.APPS_CHOWDECK_CONNECT_STORE({ connection_id: data?.data?.data?.id })}`,
      );
    },
  });

  const { isLoading: isLoadingUpdate, mutate: mutateUpdate } = useMutation({
    mutationFn: (data) => updateConnection({ id: connection_id, data }),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      navigate(`${pathConstants.APPS_CHOWDECK_CONNECTIONS}`);
    },
  });

  useEffect(() => {
    const chowdeckMarketplace = marketPlaceConnections?.find(
      (item) => String(item?.id) === connection_id,
    );

    if (chowdeckMarketplace) {
      setSecretKey(chowdeckMarketplace?.secret_key);
    }
  }, [marketPlaceConnections, connection_id]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headingContainer}>
          {connection_id ? (
            <div className={styles.textContainer}>
              <h4>Update API for this connection:</h4>
              <div style={{ gap: 8 }} className="d-flex">
                <p>
                  {
                    storesMappingList?.data?.find(
                      (item) =>
                        String(item?.marketplace_conn?.id) === connection_id,
                    )?.marketplace_store_name
                  }
                </p>
                <ConnectStoreIcon />
                <p>
                  {
                    storesMappingList?.data?.find(
                      (item) =>
                        String(item?.marketplace_conn?.id) === connection_id,
                    )?.lumi_store?.name
                  }
                </p>
              </div>
            </div>
          ) : (
            <div className={styles.textContainer}>
              <h4>API Integration</h4>
              <p>
                Set up API Integration in order to connect to Chowdeck and sync
                your products and real time orders
              </p>
            </div>
          )}
          <div className={styles.connectIcons}>
            <img src={Images.chowdeck} height={40} width={40} alt="" />
            <ChowdeckConnectIcon />
            <LumiIcon />
          </div>
        </div>
        <hr />
        <div className={styles.contentContainer}>
          <div className={styles.keyContainer}>
            <div>
              <h5>
                <span style={{ color: "red" }}>*</span>Chowdeck API Key
              </h5>
              <p>Input your API Key below to link Chowdeck to Lumi Business.</p>
            </div>
            <div className={styles.inputContainer}>
              <primaryComponents.InputField
                name="secret_key"
                value={chowdeckSecretKey || secretKey}
                classNames="white"
                label={""}
                placeholder={"Type..."}
                onChange={({ target: { value } }) =>
                  setChowdeckSecretKey
                    ? setChowdeckSecretKey(value)
                    : setSecretKey(value)
                }
              />
            </div>
            {connection_id ? (
              <div>
                <div>
                  <h5>
                    <span style={{ color: "red" }}>*</span>Your Webhook URL
                  </h5>
                  <p className="small-text-size mb-2">
                    Copy your webhook url & follow the instructions below to
                    connect it with chowdeck.
                  </p>
                </div>
                <div
                  className="d-flex justify-content-between align-items-center w-100 mb-3"
                  style={{
                    gap: "10px",
                    background: "#F2F2F2",
                    padding: 15,
                    borderRadius: 4,
                  }}
                >
                  <div>
                    <p className="dark--text small-text-size">
                      {
                        storesMappingList?.data?.find(
                          (item) =>
                            String(item?.marketplace_conn?.id) ===
                            connection_id,
                        )?.webhook_url
                      }
                    </p>
                  </div>
                  <secondaryComponents.ToolTipV2 tipText="Webwook">
                    <CopyToClipboard
                      text={
                        storesMappingList?.data?.find(
                          (item) =>
                            String(item?.marketplace_conn?.id) ===
                            connection_id,
                        )?.webhook_url
                      }
                      onCopy={() => triggerToast("Copied", "success")}
                    >
                      <primaryComponents.Button
                        classNames={"btn btn--outline smallBtn"}
                        style={{ padding: "2px 8px", height: "25px" }}
                      >
                        <img width="15px" src={Icon.copy} alt="" />{" "}
                        <span className="ml-2">Copy</span>
                      </primaryComponents.Button>
                    </CopyToClipboard>
                  </secondaryComponents.ToolTipV2>
                </div>
              </div>
            ) : null}
          </div>

          <div className={styles.contentDescription}>
            <div className={styles.howTo}>
              <p className={styles.setupTitle}>How to find your API key:</p>
              <div className={styles.keySetupSteps}>
                <div className={styles.step}>
                  <img src={Icon.keysetupone} alt="" />
                  <p>
                    Login to your Chowdeck account on{" "}
                    <a
                      href="https://dashboard.chowdeck.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span>https://dashboard.chowdeck.com</span>
                    </a>
                  </p>
                </div>
                <div className={styles.step}>
                  <img src={Icon.keysetuptwo} alt="" />
                  <p>Go to settings</p>
                </div>
                <div className={styles.step}>
                  <img src={Icon.keysetupthree} alt="" />
                  <p>Copy your secret key</p>
                </div>
                <div className={styles.step}>
                  <img src={Icon.keysetupfour} alt="" />
                  <p>
                    Paste into the &quot;<strong>Chowdeck API Key</strong>
                    &quot; above field
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.video}>
              <div
                onClick={() => setShowYouTubeModal(true)}
                className={styles.videoContainer}
              >
                <p className={styles.videoTopText}>
                  Alternatively, you can watch this short explainer video below
                  to access your secret key.
                </p>
                <div className={styles.video}>
                  <iframe
                    width="100%"
                    height="100%"
                    src={
                      "https://www.youtube.com/embed/fQoeqwSAe6Y?si=Q8tEjAvfdO_oCuxO"
                    }
                    title={"Lumi Merchant Paystack Setup"}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                  <div className={styles.overlay} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {pathname === pathConstants.APPS_CHOWDECK_API_MANAGEMENT && (
          <div className={styles.btnContainer}>
            <primaryComponents.Button
              classNames="btn btn--outline mt-auto"
              type="submit"
              onClick={() =>
                navigate(`${pathConstants.APPS_CHOWDECK_CONNECTIONS}`)
              }
            >
              Back
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames="btn btn--primary mt-auto"
              type="submit"
              isDisabled={isLoading || isLoadingUpdate}
              onClick={() => {
                if (!secretKey)
                  return triggerToast("Enter your secret to connect to API");
                if (connection_id) {
                  mutateUpdate({
                    secret_key: secretKey,
                  });
                } else {
                  mutate({
                    secret_key: secretKey,
                    type: "CHOWDECK",
                  });
                }
              }}
            >
              {isLoadingUpdate
                ? "Saving..."
                : isLoading
                  ? "Connecting..."
                  : connection_id
                    ? "Save"
                    : "Connect API"}
            </primaryComponents.Button>
          </div>
        )}
      </div>
      <secondaryComponents.Modal
        width={"850px"}
        isActive={showYouTubeModal}
        closeModal={() => setShowYouTubeModal(false)}
      >
        <div className="px-2">
          <div className={"d-flex justify-content-end align-items-center mb-3"}>
            <primaryComponents.Button
              classNames="btn btn--outline smallBtn"
              type="button"
              onClick={() => setShowYouTubeModal(false)}
            >
              Close
            </primaryComponents.Button>
          </div>
          <iframe
            width="100%"
            height="500px"
            src={
              "https://www.youtube.com/embed/fQoeqwSAe6Y?si=Q8tEjAvfdO_oCuxO"
            }
            title={"Lumi Merchant Paystack Setup"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </secondaryComponents.Modal>
    </>
  );
};

export default ApiManagement;
